module.exports = __webpack_public_path__ + "fonts/Segoe UI Bold.4b6a274.woff";